import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { Dimmer } from "../spinner";
import {
  ValidCaptcha,
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  formatoMonto,
  seleccionarCampo,
  validaNumeroTelefono,
  validaEmail,
  validaDecimal,
  formatoDeci,
} from "../../util/varios";
import axios from "axios";

export const ClasificadorProc = (props) => {
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [activate, setActivate] = useState(false);
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );
  const txtDireccionPro = useRef();
  const txtAlicuota = useRef();
  const txtMinimo = useRef();
  const txtId = useRef();
  const txtDescrip = useRef();
  const txtCodigo = useRef(null);
  const [fechas, setFechas] = useState(0.0);
  const [values, setValues] = useState({
    idclaseproduccion: "",
    codigoclaseproduccion: "",
    alicuota: 0.0,
    descripcion: "",
    minimo: 0.0,
  });
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [habilitadoNR, setHabilitadoNR] = useState(false);
  const [habilitadoNC, setHabilitadoNC] = useState("disabled");
  const [operacion, setOperacion] = useState(0);
  const [visibleF, setVisibleF] = useState("hidden");
  const [catalogo, setCatalogo] = useState(false);
  const txtEmail = useRef();
  const [tecla, setTecla] = useState();
  const [teclas, setTeclas] = useState();
  const [habilitadoNU, setHabilitadoNU] = useState({
    idclaseproduccion: false,
    codigoclaseproduccion: false,
    alicuota: false,
    descripcion: false,
    minimo: false,
  });

  const token = JSON.parse(localStorage.getItem("jwtToken"));
  let op = require("../../../public/modulos/datos");

  const onChange = (event) => {
    if (
      event.target.name === "codigoclaseproduccion" ||
      event.target.name === "descripcion"
    ) {
      event.target.value = event.target.value.toUpperCase();
    }

    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const onFecha = () => {
    let tfechas;
    let fecha = parseInt(fechaSistema.substring(1, 5));
    let mes = parseInt(fechaSistema.substring(6, 8));
    let dia = parseInt(fechaSistema.substring(9, 11));
    tfechas = fecha - 18;
    setFechas(tfechas + "-" + 0 + mes + "-" + dia);
  };

  const onFocus = (e) => {
    setHabilitadoNU({ ...habilitadoNU, [e.target.name]: true });
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
      if (event.which === 13) {
        if (event.target.id === "alicuotas") {
          txtAlicuota.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;

    if (txtCodigo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir el Código del Clasificador",
        icono: "informacion",
      });
      txtCodigo.current.focus();
      sigue = false;
    } else if (txtAlicuota.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Por Favor Introdusca el Valor de la Alicuota",
        icono: "informacion",
      });
      txtAlicuota.current.focus();
      sigue = false;
    } else if (txtMinimo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Por Favor Introdusca el Valor del Minimo",
        icono: "informacion",
      });
      txtMinimo.current.focus();
      sigue = false;
    } else if (txtDescrip.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa el Nombre del Clasificador",
        icono: "informacion",
      });
      txtDescrip.current.focus();
      sigue = false;
    } else if (sigue) {
      let msg = "";
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/produccion/actualizarproduccion/${props.operacion}`;
    let body;
    setActivate(true);

    body = {
      idclaseproduccion: parseInt(txtId.current.value),
      codigoclaseproduccion: txtCodigo.current.value.trim(),
      alicuota: parseFloat(
        txtAlicuota.current.value.trim().replace(/\./g, "").replace(",", ".")
      ),
      descripcion: txtDescrip.current.value.trim(),
      minimo: parseFloat(
        txtMinimo.current.value.trim().replace(/\./g, "").replace(",", ".")
      ),
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const blanquear = () => {
    setMostrar1(false);
    setActivate(false);
    setVisibleF("hidden");
    setHabilitadoNU({
      idclaseproduccion: false,
      codigoclaseproduccion: false,
      alicuota: false,
      descripcion: false,
      minimo: false,
    });
    setValues({
      idclaseproduccion: "",
      codigoclaseproduccion: "",
      alicuota: 0.0,
      descripcion: "",
      minimo: 0.0,
    });
    setOperacion(0);
    setMsg("");
  };

  const handleCloseSi = () => {
    Actualizar();
    setMensajesino({ mostrar: false, titulo: ".", texto: "", icono: "" });
  };

  const cancelar = (e) => {
    e.preventDefault();
    setHabilitadoNR(false);
    blanquear();
    props.onHideCancela();
  };

  const toolt = () => {
    if (txtCodigo.current.value === "") {
      txtCodigo.current.focus();
    }
  };

  const cerrarModal = () => {
    props.onHideRenderizar();
    props.onHideCancela();
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  useEffect(() => {
    onFecha();
  }, []);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        toolt();
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          setValues(props.clase);
        }
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <Modal.Title style={{ color: "#fff" }}>
          {props.operacion === 1
            ? "Agregar Clasificador de Producción."
            : props.operacion === 2
            ? "Editar Clasificador de Producción."
            : props.operacion === 3
            ? "Eliminar Clasificador de Producción."
            : "Consultar Clasificador de Producción."}
        </Modal.Title>
        <button
          ref={btnCancela}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF", color: "" }}>
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} />
        <div style={{ height: "25vh", overflow: "auto" }}>
          <div style={{ fontFamily: "Times New Roman, Times, serif" }}>
            <div className="row rounded mx-auto py-4">
              <div className="container rounded row d-flex border justify-content-between mx-auto col-md-12">
                <div className=" col-md-12 row py-3 px-4">
                  <div className="input-group input-group-sm col-sm-2">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "#55acee" }}
                      id="inputGroup-sizing-sm"
                    >
                      Código:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      disabled={true}
                      name="idclaseproduccion"
                      ref={txtId}
                      value={values.idclaseproduccion}
                    />
                  </div>

                  <div className="input-group input-group-sm col-sm-4 has-validation">
                    <label
                      htmlFor="codigoclaseproduccion"
                      className="form-label input-group-text"
                      id="validationTooltipCodigoclase"
                      style={{ backgroundColor: "#55acee" }}
                    >
                      Código/Clase:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      className="form-control"
                      id="codigoclaseproduccion"
                      aria-describedby="validationTooltipCodigoclase"
                      ref={txtCodigo}
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      name="codigoclaseproduccion"
                      value={
                        values
                          ? values.codigoclaseproduccion !== null
                            ? values.codigoclaseproduccion.trim()
                            : ""
                          : ""
                      }
                      onChange={onChange}
                      placeholder="Introduzca el Código"
                      required
                    />
                  </div>

                  <div className="input-group input-group-sm col-sm-3 has-validation">
                    <label
                      htmlFor="alicuota"
                      className="form-label input-group-text"
                      id="validationTooltipAlicuota"
                      style={{ backgroundColor: "#55acee" }}
                    >
                      Alicuota:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      className="form-control text-right"
                      aria-describedby="validationTooltipAlicuota"
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      maxLength="10"
                      name="alicuota"
                      id="alicuota"
                      ref={txtAlicuota}
                      defaultValue={
                        values && values.alicuota
                          ? formatMoneda(
                              values.alicuota
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )
                          : ""
                      }
                      onBlur={handleInputMontoChange}
                      onKeyUp={handleInputMontoChange}
                      placeholder="0,00"
                      required
                    />
                  </div>

                  <div className="input-group input-group-sm col-sm-3 has-validation">
                    <label
                      htmlFor="minimo"
                      className="form-label input-group-text"
                      id="validationTooltipMinimo"
                      style={{ backgroundColor: "#55acee" }}
                    >
                      Minimo:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      className="form-control text-right"
                      aria-describedby="validationTooltipMinimo"
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      maxLength="10"
                      name="minimo"
                      id="minimo"
                      ref={txtMinimo}
                      defaultValue={
                        values && values.minimo
                          ? formatMoneda(
                              values.minimo
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )
                          : ""
                      }
                      onBlur={handleInputMontoChange}
                      onKeyUp={handleInputMontoChange}
                      placeholder="0,00"
                      required
                    />
                  </div>
                </div>
                <div className=" col-md-12 row py-3 px-4">
                  <div className="input-group input-group-sm col-sm-12 has-validation">
                    <label
                      htmlFor="descripcion"
                      className="form-label input-group-text"
                      id="validationTooltipDescripcion"
                      style={{ backgroundColor: "#55acee" }}
                    >
                      Descripción:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      className="form-control text-uppercase"
                      aria-describedby="validationTooltipDescripcion"
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      name="descripcion"
                      id="descripcion"
                      ref={txtDescrip}
                      defaultValue={
                        values
                          ? values.descripcion
                            ? values.descripcion.trim()
                            : ""
                          : ""
                      }
                      placeholder="Describa el Nombre del Clasificador"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          disabled={operacion === 4 ? true : false}
          onClick={onChangeValidar}
          className="btn btn-sm rounded-pill btn-success col-md-2"
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill col-md-2"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/impuestoprodu/modalClasificadorProc.js